import React, { createContext, useContext, useState, ReactNode } from 'react';

interface SharedStateContextType {
	sharedState: boolean;
	setSharedState: React.Dispatch<React.SetStateAction<boolean>>;
}

// Creating a context with an initial undefined value. This is okay because we will always use it within a provider.
const SharedStateContext = createContext<SharedStateContextType | undefined>(undefined);

interface SharedStateProviderProps {
	children: ReactNode;
}

// Context Provider Component
export const SharedStateProvider: React.FC<SharedStateProviderProps> = ({ children }) => {
	const [sharedState, setSharedState] = useState<boolean>(false);

	return <SharedStateContext.Provider value={{ sharedState, setSharedState }}>{children}</SharedStateContext.Provider>;
};

// Hook to use the shared state in any component
export const useSharedState = (): SharedStateContextType => {
	const context = useContext(SharedStateContext);
	if (context === undefined) {
		throw new Error('useSharedState must be used within a SharedStateProvider');
	}
	return context;
};

// Now, you can wrap your component tree with <SharedStateProvider> and use useSharedState hook in ComponentA and ComponentB.
